import { render, staticRenderFns } from "./SidebarItemContent.vue?vue&type=template&id=e55e6de0&scoped=true"
import script from "./SidebarItemContent.vue?vue&type=script&lang=js"
export * from "./SidebarItemContent.vue?vue&type=script&lang=js"
import style0 from "./SidebarItemContent.vue?vue&type=style&index=0&id=e55e6de0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55e6de0",
  null
  
)

export default component.exports